const couponsUpdate = () =>
  import('@/views/main/cash-coupons/update/update.vue')
export default {
  path: '/main/coupons/update',
  name: 'couponsUpdate',
  component: couponsUpdate,
  children: []
}
